export default __webpack_public_path__ + "static/media/notification.d0585e19.svg";